import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgThumbsDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 11 11",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.93664 0.5L7.93665 6M10.5002 5L10.5002 1.5C10.5002 0.9477 10.0411 0.5 9.4748 0.5L2.59093 0.500001C1.83169 0.500001 1.18607 1.04015 1.07061 1.7719L0.518462 5.2719C0.375105 6.18055 1.09604 7 2.03873 7L3.83489 7C4.11806 7 4.34761 7.22386 4.34761 7.5L4.34761 9.26708C4.34761 9.94801 4.91365 10.5 5.61187 10.5C5.77845 10.5 5.92935 10.4044 5.99698 10.2559L7.80132 6.29695C7.88361 6.11635 8.06722 6 8.26985 6L9.4748 6C10.0411 6 10.5002 5.5523 10.5002 5Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgThumbsDown;
